export const statusLabel = (status) => {
  switch (status) {
    case "p":
      return "Pending"
    case "b":
      return "Blocked"
    case "a":
      return "Approved"
    default:
      return "No Status"
  }
}